module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "pagination"
  }, [(_vm.page > 1) ? _c('router-link', {
    staticClass: "pagination-link",
    attrs: {
      "to": '/' + _vm.type + '/' + (_vm.page - 1)
    }
  }, [_vm._v("\n      < Prev\n    ")]) : _c('a', {
    staticClass: "pagination-link disabled"
  }, [_vm._v("< Prev")]), _vm._v(" "), (_vm.hasMore) ? _c('router-link', {
    staticClass: "pagination-link",
    attrs: {
      "to": '/' + _vm.type + '/' + (_vm.page + 1)
    }
  }, [_vm._v("\n      Next >\n    ")]) : _c('a', {
    staticClass: "pagination-link disabled"
  }, [_vm._v("Next >")])], 1), _vm._v(" "), (!_vm.posts.length) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), _c('posts-list', {
    attrs: {
      "posts": _vm.posts,
      "start": _vm.start
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fd724a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 37
// module chunks = 0